import React from 'react';
import Card from './card/Card';
import { Button, ExtendedTheme, Heading, TextBlock } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) =>
	createStyles({
		rootoverride: {
			padding: theme.spacing(2),
			backgroundColor: theme.themeColors.blueGrey[800],
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			borderRadius: '8px',
			gap: theme.spacing(2),
			alignItems: 'center',
			[theme.breakpoints.up('sm')]: {
				flexDirection: 'row',
				padding: theme.spacing(3)
			},
			[theme.breakpoints.up('lg')]: {
				padding: theme.spacing(4)
			}
		},
		title: {
			marginBottom: theme.spacing(1),
			color: theme.themeColors.common.white
		},
		subTitle: {
			marginBottom: theme.spacing(3),
			color: theme.themeColors.blueGrey[200]
		},
		image: {
			maxWidth: '300px',
			display: 'inline-block',
			width: '100%'
		}
	})
);

export interface CallToActionCardProps {
	title: string;
	subtitle: string;
	buttonText: string;
	buttonLink: string;
	imageUrl: string;
}

export const CallToActionCard = ({ title, subtitle, buttonText, buttonLink, imageUrl }: CallToActionCardProps): JSX.Element => {
	const classes = useStyles();
	const history = useHistory();

	return (
		<Card className={classes.rootoverride}>
			<div>
				<Heading styleName="title1" className={classes.title} xs="small" md="medium">{title}</Heading>
				<TextBlock styleName="largeBody2" className={classes.subTitle} xs="small" md="medium">
					{subtitle}
				</TextBlock>
				<Button colorType="primary" size="large" onClick={() =>  history.push(buttonLink)}>{buttonText}</Button>
			</div>
			<img src={imageUrl} alt="Call to action" className={classes.image}  />
		</Card>
	);
}
